import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCurrencyLocalizer } from "../../../../hooks/useCurrencyLocalizer";
import { IconButton, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Typography from "@mui/material/Typography";
/**
 * Displays a price with responsive styles and includes an interactive edit button.
 *
 * @param {number} price - The price to display.
 * @param {boolean} disabled - If true, the edit button is disabled.
 * @param {Function} onClick - The function to call when the edit button is clicked.
 */
export const PriceDisplay = ({ price, disabled, onClick }) => {
    const { localizedCurrencyText } = useCurrencyLocalizer(price);
    return (_jsxs(Stack, Object.assign({ alignItems: "center", direction: "row", justifyContent: "flex-end" }, { children: [_jsx(Typography, { children: localizedCurrencyText }), _jsx(IconButton, Object.assign({ disabled: disabled, color: "primary", size: "small", sx: { mt: 0 }, onClick: () => onClick() }, { children: _jsx(EditIcon, { fontSize: "small" }) }))] })));
};
